import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./contactUs.css";
import Header from "../../components/common/header";
import Footer from "../../components/common/footer";
import { useUser } from "../../contexts/userContext";
import { useCart } from "../../contexts/cartContext";

interface ContactUsItem {
  block_id: number;
  code: string;
  title: string;
  html_content: string;
  is_active: number;
}

const ContactUs = () => {
  const navigate = useNavigate();
  const { checkSessionTokenExpirationStatus, handleRemoveLocalStorage,fetchCsrfToken } =
    useUser();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    email: "",
    mobile_no: "",
    message: "",
    source: 1,
  });

  const [errors, setErrors] = useState({
    name: "",
    city: "",
    email: "",
    mobile_no: "",
    message: "",
  });

  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [wrongEmail, setWrongEmail] = useState<string | null>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [mobileNo, setMobileNo] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [cities, setCities] = useState<{ name: string }[]>([]);
  const { fetchCartQuantity,cartQuantity,setCartQuantity ,handleQuantity} = useCart();
  const { setcityName, globalSearchTerm, setGlobalSearchTerm, setSessionCode, setUserId, setUsername, setUtmSessionId } = useUser();
  const [lowerImageContainer, setLowerImageContainerData] = useState<
    ContactUsItem[]
  >([]);
  const nameInputRef = useRef<HTMLInputElement>(null);
  //console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeee",errors)

  useEffect(() => {
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
    fetchSeoMetaDetails()
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
        try {
            const response = await fetch(`${backendUrl}api/v2/all-city`,
              {  method: 'GET',
                headers:{
                  // Accept:'aplication/json',
                  "Content-Type": "application/json",
                },
                 credentials: "include",
                        mode:"cors"
                                          
              }
            );
            const data = await response.json();
            if (data.data && Array.isArray(data.data[0])) {
                setCities(data.data[0]);
            }
        } catch (error) {
            //console.error('Error fetching cities:', error);
        }
    };
    fetchCities();
}, [backendUrl]);

const fetchSeoMetaDetails = async () => {
  try {
      const code = 'contact_us_page'
      const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
    
          },
          credentials: "include",
          mode:"cors"         
        }
      );
      if (!response.ok) throw new Error('Failed to fetch categories');
      const data = await response.json();
      await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
  } catch (error) {
      //console.error('Error fetching categories:', error);
  }
};

const changeTitleAndMetaTags = async (
  title: string,
  metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
) => {
  try {
      // Update the document title
      if (title) {
          document.title = title;
      } else {
          document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
      }

      // Update or create meta tags
      Object.keys(metaTags).forEach((metaName) => {
          const metaTag = document.querySelector(`meta[name="${metaName}"]`);
          if (metaTag) {
              // Update existing meta tag
              metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
          } else {
              // Create new meta tag if it doesn't exist
              const newMetaTag = document.createElement('meta');
              newMetaTag.name = metaName;
              newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
              document.head.appendChild(newMetaTag);
          }
      });

      // Cleanup function to reset the title and meta tags when unmounting
      return () => {
          document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
          Object.keys(metaTags).forEach((metaName) => {
              const metaTag = document.querySelector(`meta[name="${metaName}"]`);
              if (metaTag) {
                  metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
              }
          });
      };
  } catch (error) {
      //console.error("Error updating title and meta tags:", error);
  }
};
const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
) => {
  const { name, value, type } = e.target;

  // Remove leading spaces for `name` field
  const trimmedValue = name === 'name' ? value.trimStart() : value;
  let updatedValue = value.replace(/^\s+/g, ""); // Removes leading spaces

   if (name === 'mobile_no') {
      // Trim and allow only digits, limiting to 10 characters
      const formattedValue = updatedValue.replace(/[^0-9]/g, '').slice(0, 10);
  
      // Update the contact number in the form data
      setFormData((prevData) => ({
          ...prevData,
          mobile_no: formattedValue,
      }));
  
      // Validate the contact number
      if (formattedValue.length > 0 && formattedValue.length < 10) {
          // Set error if the number is less than 10 digits
          setErrors((prevErrors) => ({
              ...prevErrors,
              mobile_no: '10 digits required.',
          }));
      } else {
          // Clear error if the number is valid
          setErrors((prevErrors) => ({
              ...prevErrors,
              mobile_no: '',
          }));
      }
  }
  else if (name === 'name') {
      const trimmedValue = updatedValue.trim();
      const formattedValue = trimmedValue.replace(/[^a-zA-Z\s]/g, '');
    
      setFormData((prevData) => ({
        ...prevData,
        name: formattedValue,
      }));
    
      // Ensure prevErrors is always an object
      setErrors((prevErrors:any) => {
        // If prevErrors is null or a string, default to an empty object
        const errorState = prevErrors && typeof prevErrors === 'object' ? prevErrors : {};
    
        if (trimmedValue === "") {
          return { ...errorState, name: "Please enter the name" };
        } else if (trimmedValue.length < 2) {
          return { ...errorState, name: "Please enter at least two characters." };
        } else {
          return { ...errorState, name: '' }; // Clear errors if valid
        }
      });
    }
     else if (name === 'email') {
      // Update the email value in form data
      setFormData((prevData) => ({
          ...prevData,
          email: value,
      }));
  
      // Validate email format (Regex pattern for email validation)
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  
      // Check if the email format is valid
      if (value.length > 0 && !emailRegex.test(value)) {
          // Set error state if the email is invalid
          setErrors((prevErrors) => ({
              ...prevErrors,
              email: "Please enter a valid email address.",
          }));
      } else {
          // Clear the error if email is valid
          setErrors((prevErrors) => ({
              ...prevErrors,
              email: "", // Clear the error
          }));
      }
  }else if (name === 'message') {
      const trimmedValue = updatedValue.trim();
      const formattedValue = trimmedValue.replace(/[^a-zA-Z0-9\s]/g, '');
      setFormData((prevData) => ({
          ...prevData,
          message: value,
      }));

      setErrors((prevErrors:any) => {
          // If prevErrors is null or a string, default to an empty object
          const errorState = prevErrors && typeof prevErrors === 'object' ? prevErrors : {};
      
          if (trimmedValue === "") {
            return { ...errorState, message: "Please enter the message" };
          } else if (trimmedValue.length < 2) {
            return { ...errorState, message: "Please enter at least two characters." };
          } else {
            return { ...errorState, message: '' }; // Clear errors if valid
          }
        });

  }else if (name === 'city') {
    const trimmedValue = updatedValue.trim();
    // const formattedValue = trimmedValue.replace(/[^a-zA-Z0-9\s]/g, '');
    setFormData((prevData) => ({
        ...prevData,
        city: value,
    }));

    setErrors((prevErrors:any) => {
        // If prevErrors is null or a string, default to an empty object
        const errorState = prevErrors && typeof prevErrors === 'object' ? prevErrors : {};
    
        if (trimmedValue === "") {
          return { ...errorState, city: "City is required" };
        }  else {
          return { ...errorState, city: '' }; // Clear errors if valid
        }
      });

}
  else {
      setFormData((prevData) => ({
          ...prevData,
          [name]: trimmedValue,
      }));
  }
};
  

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if(errors.name !== '' || null){
      return
  }

  if(errors.message !== '' || null){
    return
}

    const newErrors: any = {
      name: formData.name ? "" : "Name is required.",
      email: formData.email ? "" : "Email is required.",
      mobile_no: formData.mobile_no ? "" : "Mobile No. is required.",
      city: formData.city ? "" : "City is required.",
      message: formData.message ? "" : "Message is required.",
    };

    setErrors(newErrors);

    if (formData.mobile_no.length < 10) {
      const newErrors: Record<string, string> = {
        mobile_no: formData.mobile_no
          ? "10 digits required."
          : "Mobile No. is required.",
      };
      setErrors((prevErrors) => ({
        ...prevErrors,
        ...newErrors,
      }));
      return;
    }

    setIsLoading(true);
    
      try {
        const csrfToken = await fetchCsrfToken();
        const response = await fetch(`${backendUrl}api/v2/support-query`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify(formData),
          
        });
  
        const data = await response.json();
        if (response.ok) {
          if(data.data.smtp==true){
            setWrongEmail('Your query has been submitted. However, the email-id provided by you is incorrect.')
          }else{
            setWrongEmail('Your query has been submitted successfully.')
          }
          
          setSuccess("Your query has been submitted successfully.");
          setError(null);
          setShowPopup(true);
         
        } else {
          setError(data.message || "Error in submitting the form.");
        }
      } catch (error: any) {
        setError(error.message || "An error occurred.");
      } finally {
        setIsLoading(false); // End loading
      }
    

   
  };

  const fetchData = async (
    code: string,
    setter: React.Dispatch<React.SetStateAction<ContactUsItem[]>>
  ) => {
    try {
      const response = await fetch(
        `${backendUrl}${version}All-tempelate/${code}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json"
    
          },
          credentials: "include",
          mode:"cors"            
        }
      );
      const data = await response.json();
      if (Array.isArray(data.data)) {
        setter(data.data);
      } else {
        setter([]);
      }
    } catch (error) {
      setter([]);
    }
  };

  useEffect(() => {
    fetchData("contact_us_nos", setLowerImageContainerData);
  }, []);

  const handlePopupClose = () => {
    setShowPopup(false);
    setFormData({
      name: "",
      city: "",
      email: "",
      mobile_no: "",
      message: "",
      source: 1,
    });
  };

  useEffect(() => {
    const isSessionHandled = sessionStorage.getItem("sessionHandled");
  
    // If the session was already handled, avoid running this logic again
    if (isSessionHandled) return;
  
    // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
  
    if (checkSessionTokenExpirationStatus()) {
      // Clear session-related operations
      handleQuantity();
      handleRemoveLocalStorage();
  
      // Set the sessionHandled flag to true to prevent re-execution after reload
      sessionStorage.setItem("sessionHandled", "true");
  
      // Redirect to the homepage
      navigate("/");
  
      // Reload the page to clear cache
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = "hidden"; // Disable background scroll
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling when popup is closed
    }
  
    return () => {
      document.body.style.overflow = "auto"; // Cleanup on unmount
    };
  }, [showPopup]);

  return (
    <div>
      <Header />
      <main className="main-content-contact-us-page">
        <div className="contact-main-container container">
        <div className="section_breadcrumb">
         <div className="container-">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <a>Contact us</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
          <div className="contact-us-container">
            <div className="contact-us-info">
              {lowerImageContainer.map((item) => (
                <div key={item.block_id}>
                  <div
                    className="html-content"
                    dangerouslySetInnerHTML={{ __html: item.html_content }}
                  />
                </div>
              ))}
            </div>

            <div className="contact-us-form">
              <h5>Contact Us</h5>
              {isLoading && (
        <div className="loading-overlay">
          <div className="loader"></div>
        </div>
      )}
              <form onSubmit={handleSubmit}>
                <div className="contact-us-form-row row">
                  <div className="contact-us-form-group form-group col-md-6">
                    <label>Your Name<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your name"
                      maxLength={50}
                      ref={nameInputRef}
                      className={`contact-us-input ${
                        errors.name ? "input-error" : ""
                      }`}
                    />
                    {errors.name && (
                      <span className="error-message-reg">{errors.name}</span>
                    )}
                  </div>
                  <div className="contact-us-form-group form-group col-md-6">
                    <label>Email<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      maxLength={50}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className={`contact-us-input ${
                        errors.email ? "input-error" : ""
                      }`}
                    />
                    {errors.email && (
                      <span className="error-message-reg">{errors.email}</span>
                    )}
                  </div>
                </div>
                <div className="contact-us-form-row row">
                  <div className="contact-us-form-group form-group col-md-6">
                    <label>Mobile No.<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      name="mobile_no"
                      value={formData.mobile_no}
                      onChange={handleChange}
                      placeholder="Enter your mobile number"
                      className={`contact-us-input ${
                        errors.mobile_no ? "input-error" : ""
                      }`}
                    />
                    {errors.mobile_no && (
                      <span className="error-message-reg">
                        {errors.mobile_no}
                      </span>
                    )}
                  </div>
                  <div className="contact-us-form-group form-group col-md-6">
                  <label>City<span style={{ color: 'red' }}>*</span></label>
                                    <select
                                        id="city"
                                        className="form-control custom-select form-select"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        // required
                                    >
                                       <option value="" disabled selected>
    Select City
</option>
{cities.map((city) => (
    <option key={city.name} value={city.name}>
        {city.name}
    </option>
))}
                                    </select>
                    {errors.city && (
                      <span className="error-message-reg">
                        {errors.city}
                      </span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="contact-us-form-group form-group">
                    <label>Message<span style={{ color: 'red' }}>*</span></label>
                    <textarea
                      name="message"
                      value={formData.message ?? ""}
                      maxLength={255}
                      onChange={handleChange}
                      placeholder="Enter your message"
                      className={`contact-us-textarea form-control ${
                        errors.message ? "input-error" : ""
                      }`}
                    >
                      
                    </textarea>
                    {errors.message && (
                        <span className="error-message-reg">
                          {errors.message}
                        </span>
                      )}
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  // disabled={isLoading} // Disable button while loading
                >
                  Submit
                </button>
                {/* {success && <p className="success">{success}</p>} */}
              </form>
            </div>
          </div>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.600059836369!2d77.37185017495597!3d28.611772585024063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce451e84e476b%3A0x4f248fab3776eeb!2sAttero%20Recycling%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1715796096100!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              loading="lazy"
            ></iframe>
          </div>
          {showPopup && (
            <div className="popup-overlay">
              <div className="popup-content">
                <h2>Success!</h2>
                {/* <p></p> */}
                <p>{wrongEmail}</p>
                <button onClick={handlePopupClose} className="popup-close-btn">
                  Got it
                </button>
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ContactUs;
